import jsPDF from 'jspdf';
import 'jspdf-autotable';
import VisusLogo from '../statics/VISUS_Logo_RGB_color.png';

// Modalitätenliste - kopiert aus StructuredReporting.js
const ALL_MODALITIES_RAW = [
  // Standard-Modalitäten
  { code: 'DX', name: 'Digitale Radiographie' },
  { code: 'CT', name: 'Computertomographie' },
  { code: 'MR', name: 'Magnetresonanztomographie' },
  { code: 'RF', name: 'Radiofluoroskopie' },
  { code: 'XA', name: 'Röntgen-Angiographie' },
  { code: 'MG', name: 'Mammographie' },
  { code: 'US', name: 'Ultraschall' },
  // Erweiterte Modalitäten (alphabetisch)
  { code: 'AR', name: 'Autorefraktion' },
  { code: 'ASMT', name: 'Inhaltsbewertungsergebnisse' },
  { code: 'AU', name: 'Audio' },
  { code: 'BDUS', name: 'Knochendichtemessung (Ultraschall)' },
  { code: 'BI', name: 'Biomagnetische Bildgebung' },
  { code: 'BMD', name: 'Knochendichtemessung (Röntgen)' },
  { code: 'CR', name: 'Computed Radiography' },
  { code: 'CTPROTOCOL', name: 'CT-Protokoll (durchgeführt)' },
  { code: 'DG', name: 'Diaphanographie' },
  { code: 'DOC', name: 'Dokument' },
  { code: 'ECG', name: 'Elektrokardiographie' },
  { code: 'EPS', name: 'Kardiale Elektrophysiologie' },
  { code: 'ES', name: 'Endoskopie' },
  { code: 'FID', name: 'Referenzmarker' },
  { code: 'GM', name: 'Allgemeine Mikroskopie' },
  { code: 'HC', name: 'Hardcopy' },
  { code: 'HD', name: 'Hämodynamische Wellenform' },
  { code: 'IO', name: 'Intraorale Radiographie' },
  { code: 'IOL', name: 'Intraokuläre Linsendaten' },
  { code: 'IVOCT', name: 'Intravaskuläre optische Kohärenztomographie' },
  { code: 'IVUS', name: 'Intravaskulärer Ultraschall' },
  { code: 'KER', name: 'Keratometrie' },
  { code: 'KO', name: 'Schlüsselobjektauswahl' },
  { code: 'LEN', name: 'Linsenmessung' },
  { code: 'LS', name: 'Laser-Oberflächenscan' },
  { code: 'M3D', name: 'Modell für 3D-Fertigung' },
  { code: 'NM', name: 'Nuklearmedizin' },
  { code: 'OAM', name: 'Ophthalmische Axialmessungen' },
  { code: 'OCT', name: 'Optische Kohärenztomographie (nicht-ophthalmisch)' },
  { code: 'OP', name: 'Ophthalmische Fotographie' },
  { code: 'OPM', name: 'Ophthalmische Kartierung' },
  { code: 'OPT', name: 'Ophthalmische Tomographie' },
  { code: 'OPTBSV', name: 'Ophthalmische Tomographie B-Scan-Volumenanalyse' },
  { code: 'OPTENF', name: 'Ophthalmische Tomographie En Face' },
  { code: 'OPV', name: 'Ophthalmisches Gesichtsfeld' },
  { code: 'OSS', name: 'Optischer Oberflächenscan' },
  { code: 'OT', name: 'Andere' },
  { code: 'PLAN', name: 'Plan' },
  { code: 'PR', name: 'Präsentationsstatus' },
  { code: 'PT', name: 'Positronen-Emissions-Tomographie' },
  { code: 'PX', name: 'Panorama-Röntgen' },
  { code: 'REG', name: 'Registrierung' },
  { code: 'RESP', name: 'Atemwellenform' },
  { code: 'RG', name: 'Radiographische Bildgebung (konventioneller Film/Bildschirm)' },
  { code: 'RTDOSE', name: 'Strahlentherapie-Dosis' },
  { code: 'RTIMAGE', name: 'Strahlentherapie-Bild' },
  { code: 'RTINTENT', name: 'Strahlentherapie-Absicht' },
  { code: 'RTPLAN', name: 'Strahlentherapie-Plan' },
  { code: 'RTRAD', name: 'RT-Strahlung' },
  { code: 'RTRECORD', name: 'RT-Behandlungsprotokoll' },
  { code: 'RTSEGANN', name: 'Strahlentherapie-Segmentannotation' },
  { code: 'RTSTRUCT', name: 'Strahlentherapie-Struktursatz' },
  { code: 'RWV', name: 'Real-World-Wert-Karte' },
  { code: 'SEG', name: 'Segmentierung' },
  { code: 'SM', name: 'Objektträger-Mikroskopie' },
  { code: 'SMR', name: 'Stereometrische Beziehung' },
  { code: 'SR', name: 'SR-Dokument' },
  { code: 'SRF', name: 'Subjektive Refraktion' },
  { code: 'STAIN', name: 'Automatischer Objektträger-Färber' },
  { code: 'TG', name: 'Thermographie' },
  { code: 'VA', name: 'Sehschärfe' },
  { code: 'XC', name: 'Externe Kamera-Fotographie' }
];

// Automatische ID-Generierung für Modalitäten (Index + 1)
const ALL_MODALITIES = ALL_MODALITIES_RAW.map((modality, index) => ({
  ...modality,
  id: index + 1
}));

// CSV Format Guide Generator für strukturierte Templates
export const generateCSVGuide = () => {
  const pdf = new jsPDF('portrait', 'mm', 'a4'); // Hochformat!
  
  // Logo oben rechts hinzufügen
  try {
    // Logo-Dimensionen (60px Höhe entspricht etwa 21mm bei 72 DPI)
    const logoHeight = 21; // mm
    const logoWidth = logoHeight * 2.5; // Angenommenes Seitenverhältnis für VISUS Logo
    const pageWidth = pdf.internal.pageSize.getWidth();
    const logoX = pageWidth - logoWidth - 15; // 15mm Abstand vom rechten Rand
    const logoY = 10; // 10mm vom oberen Rand
    
    // Logo direkt aus Import verwenden
    pdf.addImage(VisusLogo, 'PNG', logoX, logoY, logoWidth, logoHeight);
  } catch (error) {
    console.warn('Logo konnte nicht geladen werden:', error);
    // Fallback: Text-Platzhalter
    const pageWidth = pdf.internal.pageSize.getWidth();
    pdf.setFontSize(10);
    pdf.setTextColor(100, 100, 100);
    pdf.text('VISUS', pageWidth - 25, 20);
    pdf.setTextColor(0, 0, 0);
  }
  
  // Titel (unter dem Logo, links positioniert)
  pdf.setFontSize(18);
  pdf.text('CSV-Format Anleitung - Strukturierte Templates', 20, 40);
  
  // Übersicht der CSV-Spalten
  pdf.setFontSize(14);
  pdf.text('CSV-Spalten Überblick', 20, 55);
  
  const columnData = [
    ['Spalte', 'Name', 'Beschreibung', 'Beispielwerte'],
    ['A', 'template_id', 'Template-ID (bei mehreren Templates)', '1, 2, 3'],
    ['B', 'template_name', 'Name des Templates', 'CT Thorax Befundung'],
    ['C', 'element_type', 'Art des Elements', 'field, group, finding'],
    ['D', 'order', 'Reihenfolge der Elemente', '1, 2, 3, 4'],
    ['E', 'label/name', 'Bezeichnung des Elements', 'Befund, Patientendaten'],
    ['F', 'subtitle', 'Untertitel (nur für Findings)', 'Rechts, Links, Anterior'],
    ['G', 'type', 'Feldtyp (für Fields)', 'freetext, database'],
    ['H', 'database_field', 'Datenbankfeld (für Fields)', 'patient_name, birth_date'],
    ['I', 'width', 'Breite (für Fields, 1-12)', '6, 12, 8'],
    ['J', 'height', 'Höhe (für Fields, 1-10)', '3, 5, 2'],
    ['K', 'finding_type', 'Art des Findings', 'freetext, dropdown, checkboxes'],
    ['L', 'placeholder', 'Platzhaltertext', 'Bitte eingeben...'],
    ['M', 'unit', 'Einheit (für freetext_unit)', 'mm, cm, %, ml/m²'],
    ['N', 'custom_unit', 'Benutzerdefinierte Einheit', 'mmHg, kg/m²'],
    ['O', 'options', 'Optionen (Semikolon-getrennt)', 'Normal;Pathologisch;Unklar'],
    ['P', 'comment_placeholder', 'Kommentar-Platzhalter', 'Zusätzliche Bemerkungen'],
    ['Q', 'group_id', 'Gruppen-ID für Findings', 'group_123456789'],
    ['R', 'findings', 'Findings in Gruppe (JSON)', '[{"name":"Finding1"}]'],
    ['S', 'standard_for_type', 'Standard-für Typ', 'all, modalities, examinations'],
    ['T', 'standard_for_values', 'Standard-für Werte (Komma-getrennt)', '1,2,3'],
    ['U', 'template_type', 'Template-Typ', 'S (für Strukturiert)']
  ];

  pdf.autoTable({
    head: [columnData[0]],
    body: columnData.slice(1),
    startY: 65,
    styles: { 
      fontSize: 8,
      halign: 'left',
      cellPadding: 2
    },
    headStyles: { 
      fillColor: [41, 128, 185],
      halign: 'left'
    },
    margin: { left: 15, right: 15 },
    columnStyles: {
      0: { cellWidth: 15 },
      1: { cellWidth: 35 },
      2: { cellWidth: 70 },
      3: { cellWidth: 50 }
    }
  });

  // Element-Typen Details
  let yPosition = pdf.autoTable.previous.finalY + 15;
  
  if (yPosition > 220) {
    pdf.addPage();
    yPosition = 20;
  }
  
  pdf.setFontSize(14);
  pdf.text('Element-Typen Details', 20, yPosition);
  
  yPosition += 10;
  
  const elementTypeData = [
    ['Element-Typ', 'Verwendung', 'Erforderliche Spalten', 'Beispiel'],
    ['field', 'Freitextfeld oder Datenbankfeld', 'label, type, width, height', 'Befundtext'],
    ['group', 'Gruppierung von Findings', 'name, findings (JSON)', 'Lungenbefund'],
    ['finding', 'Strukturierter Befundpunkt', 'name, finding_type, + typ-spezifisch', 'Pleuraerguss']
  ];

  pdf.autoTable({
    head: [elementTypeData[0]],
    body: elementTypeData.slice(1),
    startY: yPosition,
    styles: { 
      fontSize: 9,
      halign: 'left',
      cellPadding: 3
    },
    headStyles: { 
      fillColor: [46, 125, 50],
      halign: 'left'
    },
    margin: { left: 15, right: 15 }
  });

  // Finding-Typen
  yPosition = pdf.autoTable.previous.finalY + 15;
  
  if (yPosition > 180) {
    pdf.addPage();
    yPosition = 20;
  }

  pdf.setFontSize(14);
  pdf.text('Finding-Typen', 20, yPosition);
  
  yPosition += 10;
  
  const findingTypeData = [
    ['Finding-Typ', 'Beschreibung', 'Zusätzliche Spalten', 'Beispiel-Options'],
    ['freetext', 'Freier Text', 'placeholder', '-'],
    ['freetext_unit', 'Text mit Einheit', 'placeholder, unit/custom_unit', 'mm, cm, %'],
    ['dropdown', 'Auswahlliste', 'options (Semikolon-getrennt)', 'Normal;Pathologisch;Unklar'],
    ['checkboxes', 'Mehrfachauswahl', 'options (Semikolon-getrennt)', 'Option1;Option2;Option3'],
    ['yesno_comment', 'Ja/Nein mit Kommentar', 'comment_placeholder', '-']
  ];

  pdf.autoTable({
    head: [findingTypeData[0]],
    body: findingTypeData.slice(1),
    startY: yPosition,
    styles: { 
      fontSize: 9,
      halign: 'left',
      cellPadding: 3
    },
    headStyles: { 
      fillColor: [156, 39, 176],
      halign: 'left'
    },
    margin: { left: 15, right: 15 }
  });

  // Verfügbare Units
  yPosition = pdf.autoTable.previous.finalY + 15;
  
  if (yPosition > 180) {
    pdf.addPage();
    yPosition = 20;
  }

  pdf.setFontSize(14);
  pdf.text('Verfügbare Einheiten', 20, yPosition);
  
  yPosition += 10;
  
  const unitsData = [
    ['Einheit', 'Beschreibung'],
    ['mm', 'Millimeter'],
    ['cm', 'Zentimeter'],
    ['ml/m²', 'Milliliter pro Quadratmeter'],
    ['%', 'Prozent'],
    ['g/m²', 'Gramm pro Quadratmeter'],
    ['MS', 'Millisekunden'],
    ['custom', 'Benutzerdefiniert (custom_unit Spalte verwenden)']
  ];

  pdf.autoTable({
    head: [unitsData[0]],
    body: unitsData.slice(1),
    startY: yPosition,
    styles: { 
      fontSize: 10,
      halign: 'left',
      cellPadding: 3
    },
    headStyles: { 
      fillColor: [255, 152, 0],
      halign: 'left'
    },
    margin: { left: 15, right: 15 }
  });

  // Datenbankfelder auf neuer Seite
  pdf.addPage();
  
  pdf.setFontSize(14);
  pdf.text('Verfügbare Datenbankfelder', 20, 20);
  
  const dbFieldsData = [
    ['Feldname', 'Beschreibung'],
    ['patient_id', 'Patienten-ID'],
    ['patient_name', 'Patientenname'],
    ['birth_date', 'Geburtsdatum'],
    ['sex', 'Geschlecht'],
    ['modality', 'Modalität'],
    ['study_description', 'Untersuchungsbeschreibung'],
    ['clinical_info', 'Klinische Information'],
    ['question', 'Fragestellung'],
    ['accession_number', 'Zugriffsnummer'],
    ['referring_physician', 'Zuweisender Arzt'],
    ['admission_id', 'Aufnahme-ID'],
    ['comment', 'Kommentar'],
    ['scan_protocol', 'Scan-Protokoll'],
    ['first_reader', 'Erstbefunder'],
    ['patientsAge', 'Patientenalter'],
    ['patientsWeight', 'Patientengewicht'],
    ['patientsSize', 'Patientengröße'],
    ['occupation', 'Beruf'],
    ['additionalPatientsHistory', 'Zusätzliche Patientengeschichte'],
    ['admittingDiagnosesDescription', 'Aufnahmediagnose-Beschreibung']
  ];

  pdf.autoTable({
    head: [dbFieldsData[0]],
    body: dbFieldsData.slice(1),
    startY: 35,
    styles: { 
      fontSize: 10,
      halign: 'left',
      cellPadding: 3
    },
    headStyles: { 
      fillColor: [76, 175, 80],
      halign: 'left'
    },
    margin: { left: 15, right: 15 }
  });

  // Modalitäten-Liste auf neuer Seite
  pdf.addPage();
  
  pdf.setFontSize(14);
  pdf.text('Vollständige Modalitäten-Liste', 20, 20);
  pdf.setFontSize(10);
  pdf.text(`Für standard_for_type="modalities" und standard_for_values (${ALL_MODALITIES.length} Modalitäten)`, 20, 30);
  
  // Aufteilen in Spalten für bessere Platznutzung
  const modalitiesPerColumn = 22; // Etwa 22 pro Seite
  let currentModalities = [...ALL_MODALITIES];
  let pageNumber = 1;
  
  while (currentModalities.length > 0) {
    const currentPageModalities = currentModalities.splice(0, modalitiesPerColumn);
    
    if (pageNumber > 1) {
      pdf.addPage();
      pdf.setFontSize(14);
      pdf.text(`Modalitäten-Liste (Fortsetzung)`, 20, 20);
    }
    
    pdf.autoTable({
      head: [['ID', 'Code', 'Name']],
      body: currentPageModalities.map(m => [m.id.toString(), m.code, m.name]),
      startY: pageNumber === 1 ? 40 : 30,
      styles: { 
        fontSize: 9,
        halign: 'left',
        cellPadding: 2
      },
      headStyles: { 
        fillColor: [63, 81, 181],
        halign: 'left'
      },
      margin: { left: 15, right: 15 },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 30 },
        2: { cellWidth: 120 }
      }
    });
    
    pageNumber++;
  }

  // CSV-Beispiel auf neuer Seite
  pdf.addPage();
  
  pdf.setFontSize(14);
  pdf.text('CSV-Beispiel', 20, 20);
  
  pdf.setFontSize(9);
  const exampleText = `
Beispiel einer CSV-Datei für ein strukturiertes Template:

template_id,template_name,element_type,order,label/name,subtitle,type,database_field,width,height,finding_type,placeholder,unit,custom_unit,options,comment_placeholder,group_id,findings,standard_for_type,standard_for_values,template_type
1,"CT Thorax Befundung",field,1,"Patientendaten",,database,patient_name,6,1,,,,,,,,,all,,S
1,"CT Thorax Befundung",field,2,"Klinische Angaben",,freetext,,12,3,,"Klinische Fragestellung eingeben",,,,,,all,,S
1,"CT Thorax Befundung",group,3,"Lungenbefund",,,,,,,,,,,,,"[{""name"":""Pleuraerguss"",""finding_type"":""dropdown"",""options"":[""Kein"",""Rechts"",""Links"",""Beidseits""]}]",all,,S
1,"CT Thorax Befundung",finding,4,"Herzgröße",,,,,,dropdown,,"","",Normgroß;Vergrößert;Verkleinert,,,all,,S

Wichtige Hinweise:
- Leere Zeile zwischen verschiedenen Templates bei Multi-Template-Export
- JSON-Format für findings-Spalte bei Gruppen
- Semikolon-Trennung für options
- Komma-Trennung für standard_for_values
- Anführungszeichen um Text mit Kommas oder Sonderzeichen
- Bei standard_for_type="modalities": Modalitäten-IDs aus obiger Liste verwenden
- Bei standard_for_type="examinations": Untersuchungs-IDs verwenden
- template_type muss immer "S" sein für strukturierte Templates

Standard-für Beispiele:
- Alle Templates: standard_for_type="all", standard_for_values leer
- Nur CT und MR: standard_for_type="modalities", standard_for_values="2,3"
- Bestimmte Untersuchungen: standard_for_type="examinations", standard_for_values="1,5,8"

Validierungsregeln:
- template_name ist erforderlich
- element_type muss "field", "group" oder "finding" sein
- order muss eine Zahl > 0 sein
- Bei element_type="field": type, width, height erforderlich
- Bei element_type="finding": finding_type erforderlich
- Bei finding_type="dropdown" oder "checkboxes": options erforderlich
- template_type muss "S" sein
`;

  const lines = exampleText.trim().split('\n');
  let currentY = 35;
  
  lines.forEach(line => {
    if (currentY > 270) {
      pdf.addPage();
      currentY = 20;
    }
    
    // Lange Zeilen umbrechen für bessere Lesbarkeit
    if (line.length > 120) {
      const words = line.split(' ');
      let currentLine = '';
      
      words.forEach(word => {
        if ((currentLine + word).length > 120) {
          pdf.text(currentLine, 20, currentY);
          currentY += 4;
          if (currentY > 270) {
            pdf.addPage();
            currentY = 20;
          }
          currentLine = word + ' ';
        } else {
          currentLine += word + ' ';
        }
      });
      
      if (currentLine.trim()) {
        pdf.text(currentLine.trim(), 20, currentY);
        currentY += 4;
      }
    } else {
      pdf.text(line, 20, currentY);
      currentY += 4;
    }
  });

  return pdf;
};

// Helper function to download CSV with guide
export const downloadCSVGuideWithData = (csvData, templateName) => {
  // Create CSV blob
  const csvBlob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  
  // Generate guide PDF
  const guidePdf = generateCSVGuide();
  
  // Download CSV
  const csvUrl = URL.createObjectURL(csvBlob);
  const csvLink = document.createElement('a');
  csvLink.href = csvUrl;
  csvLink.download = `${templateName}_Export.csv`;
  document.body.appendChild(csvLink);
  csvLink.click();
  document.body.removeChild(csvLink);
  URL.revokeObjectURL(csvUrl);
  
  // Download PDF guide
  guidePdf.save('CSV_Format_Anleitung_Strukturierte_Templates.pdf');
}; 